module.exports = (__webpack_require__(8))(132);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/font-awesome/css/font-awesome.css from dll-reference vendor_0c24fb4ba06bcd34cf1f
// module id = 57
// module chunks = 53